/* tslint:disable */
/* eslint-disable */
/**
 * PRMGApp
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import * as runtime from '../runtime';
import { CarWithUsageDtoListGenericApiResponseFromJSON, DeliverReturnHistoryResultPagedResultGenericApiResponseFromJSON, GroupedCalendarDtoListGenericApiResponseFromJSON, } from '../models';
/**
 *
 */
export class CalendarApi extends runtime.BaseAPI {
    /**
     */
    apiCalendarAvailableBeginsEndsGetRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.begins === null || requestParameters.begins === undefined) {
                throw new runtime.RequiredError('begins', 'Required parameter requestParameters.begins was null or undefined when calling apiCalendarAvailableBeginsEndsGet.');
            }
            if (requestParameters.ends === null || requestParameters.ends === undefined) {
                throw new runtime.RequiredError('ends', 'Required parameter requestParameters.ends was null or undefined when calling apiCalendarAvailableBeginsEndsGet.');
            }
            const queryParameters = {};
            if (requestParameters.plateNumber !== undefined) {
                queryParameters['PlateNumber'] = requestParameters.plateNumber;
            }
            if (requestParameters.modelId !== undefined) {
                queryParameters['ModelId'] = requestParameters.modelId;
            }
            if (requestParameters.makeId !== undefined) {
                queryParameters['MakeId'] = requestParameters.makeId;
            }
            const headerParameters = {};
            const response = yield this.request({
                path: `/api/Calendar/available/{begins}/{ends}`.replace(`{${"begins"}}`, encodeURIComponent(String(requestParameters.begins))).replace(`{${"ends"}}`, encodeURIComponent(String(requestParameters.ends))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => CarWithUsageDtoListGenericApiResponseFromJSON(jsonValue));
        });
    }
    /**
     */
    apiCalendarAvailableBeginsEndsGet(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.apiCalendarAvailableBeginsEndsGetRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     */
    apiCalendarHistoryGetRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            if (requestParameters.limit !== undefined) {
                queryParameters['limit'] = requestParameters.limit;
            }
            if (requestParameters.page !== undefined) {
                queryParameters['page'] = requestParameters.page;
            }
            const headerParameters = {};
            const response = yield this.request({
                path: `/api/Calendar/history`,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => DeliverReturnHistoryResultPagedResultGenericApiResponseFromJSON(jsonValue));
        });
    }
    /**
     */
    apiCalendarHistoryGet(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.apiCalendarHistoryGetRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     */
    apiCalendarReservedBeginsEndsGetRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.begins === null || requestParameters.begins === undefined) {
                throw new runtime.RequiredError('begins', 'Required parameter requestParameters.begins was null or undefined when calling apiCalendarReservedBeginsEndsGet.');
            }
            if (requestParameters.ends === null || requestParameters.ends === undefined) {
                throw new runtime.RequiredError('ends', 'Required parameter requestParameters.ends was null or undefined when calling apiCalendarReservedBeginsEndsGet.');
            }
            const queryParameters = {};
            if (requestParameters.modelId !== undefined) {
                queryParameters['ModelId'] = requestParameters.modelId;
            }
            if (requestParameters.makeId !== undefined) {
                queryParameters['MakeId'] = requestParameters.makeId;
            }
            if (requestParameters.plateNumbers) {
                queryParameters['PlateNumbers'] = requestParameters.plateNumbers;
            }
            const headerParameters = {};
            const response = yield this.request({
                path: `/api/Calendar/reserved/{begins}/{ends}`.replace(`{${"begins"}}`, encodeURIComponent(String(requestParameters.begins))).replace(`{${"ends"}}`, encodeURIComponent(String(requestParameters.ends))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => GroupedCalendarDtoListGenericApiResponseFromJSON(jsonValue));
        });
    }
    /**
     */
    apiCalendarReservedBeginsEndsGet(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.apiCalendarReservedBeginsEndsGetRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
}
